import React from 'react';
import GenericFeatures from '../GenericFeatures';
import styles from './styles.scss';

const FEATURES = [
  {
    name: 'Online textbook',
    icon: 'fad fa-books',
    description:
      'Our online textbook is easy to read and mobile-friendly. Written by Wes Carroll, an industry-leading expert with many years of experience.',
  },
  {
    name: 'Memory-tracked quiz questions',
    icon: 'fad fa-user-chart',
    description:
      "Prepare in less time with hundreds of quizzes. As you study, Achievable's advanced learning engine updates a personalized model of your memory to efficiently cover all material while focusing on your trickiest topics.",
  },
  {
    name: 'A full year of access',
    icon: 'fad fa-calendar-check',
    description:
      "You'll have plenty of time to prepare. And if life gets in the way, just let us know. We're people too and we understand.",
  },
  {
    name: 'Direct access to the course author',
    icon: 'fad fa-users',
    description: (
      <div>
        <p>
          During the 2021-22 competition season, this course includes enrollment in author
          and coach Wes Carroll&apos;s private <b>AMC Channel</b>, a direct video
          communication platform that gives you personal support directly from Wes.
        </p>
        <p>We want to help you succeed!</p>
      </div>
    ),
  },
];

const QUOTE = {
  text: "The course is fantastic; I've never used flashcards to study before, but I'm retaining the information much better than I ever had. ...Thanks so much for making this great course!",
  source: 'Micah T.',
};

const Quote = (props) => {
  const { quote } = props;
  const { text, source } = quote;

  return (
    <div className={styles.quote}>
      <i className="fad fa-star" />
      <i className="fad fa-star" />
      <i className="fad fa-star" />
      <i className="fad fa-star" />
      <i className="fad fa-star" />
      <div className={styles.quoteText}>&quot;{text}&quot;</div>
      <div>~ {source} ~</div>
    </div>
  );
};

const DefaultFeatures = () => (
  <div>
    <GenericFeatures features={FEATURES} />
    <Quote quote={QUOTE} />
    <div className={styles.layout}>
      <div className={styles.title}>LAST-MINUTE ACCESS</div>
      <div>
        <p>
          The 2021 AMC 10/12 exams are scheduled for mid-November. For the final weeks of
          the competition preparation season (i.e. now), you can buy full access to this
          course and all support channels for a <b>discounted price</b>.
        </p>
        <p>
          Diligent preparation with this course has been shown to be remarkably effective
          in 30 to 60 minutes per day over 7-10 consecutive days. If you&apos;re ready to
          put in the time, <b>it works</b>. But there&apos;s no time to delay.
        </p>
        <p>
          Get your discount, block time on your calendar, and <b>get to work</b>.
          Let&apos;s do this!
        </p>
      </div>
    </div>
  </div>
);

export default DefaultFeatures;
